import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

const NotFoundPage = () => (
  <div className="not-found-page">
    <h1 className="not-found-page-title">404</h1>
    <p className="not-found-page-description">
      <FormattedMessage
        id="not_found_page.not-found"
        defaultMessage="Not found"
      />
    </p>
    <Link to="/" className="btn btn-primary btn-md">
      <i className="icon-chevron-right" />
      <FormattedMessage id="not_found_page.back" defaultMessage="Back to homepage" />
    </Link>
  </div>
);

export default NotFoundPage;
